// A tiny bridge so code outside the React tree (the store) can navigate.
// App registers the router's navigate function once on mount.
let _navigate = null;

export const setNavigate = (fn) => {
  _navigate = fn;
};

export const go = (to, opts) => {
  if (_navigate) _navigate(to, opts);
};